import { createTheme, Theme } from "@mui/material";


export interface IThemeSettings
{
    mui: {};
    settings: {
        title: string;
        loginTitle: string;
        icon: string;
        images: {
            logoLogin: string;
        };
    };
    css: {};
}

export const defaultThemeSettings: IThemeSettings =
{
    mui: {
        palette: {
            primary: {
              light: '#ffde59',
              main: '#ffd631',
              dark: '#b89a23',
            },
            secondary: {
                main: "#70405f"
            }
        },
        typography: {
            fontFamily : '"Roboto", sans-serif;',
            h5: {
              fontWeight: 500,
              fontSize: 26,
              letterSpacing: 0.5,
            },
        },
        shape: {
            borderRadius: 8,
        },
        components: {
            MuiTab: {
                defaultProps: {
                    disableRipple: true,
                },
            },
        },
        mixins: {
            toolbar: {
                minHeight: 48,
            },
        }
    },
    settings: {
        title: "Demo - Web Integration",
        loginTitle: "Demo Login",
        icon: "./assets/favicon.png",
        images: {
            logoLogin: ""
        },
    },
    css: {
        appBarUsernameText: {
            fontWeight: "bold"
        },
        appBarVersion: {
            fontWeight: "bold"
        }
    }
}

export interface IBaseTheme extends Theme {

    title: string;
    loginTitle: string;
    icon: string;
    images: {
        logoLogin: string;
    };
}

const theme = createTheme({
    ...defaultThemeSettings.mui
});

export const defaultTheme : IBaseTheme = {
    ...theme,
    ...defaultThemeSettings.settings,
    components: {
        MuiDrawer: {
          styleOverrides: {
            paper: {
              backgroundColor: '#70405f',
            },
          },
        },
        MuiButton: {
          styleOverrides: {
            root: {
              textTransform: 'none',
            },
            contained: {
              boxShadow: 'none',
              '&:active': {
                boxShadow: 'none',
              },
            },
          },
        },
        MuiTabs: {
          styleOverrides: {
            root: {
              marginLeft: theme.spacing(1),
            },
            indicator: {
              height: 3,
              borderTopLeftRadius: 3,
              borderTopRightRadius: 3,
              backgroundColor: theme.palette.common.white,
            },
          },
        },
        MuiTab: {
          styleOverrides: {
            root: {
              textTransform: 'none',
              margin: '0 16px',
              minWidth: 0,
              padding: 0,
              [theme.breakpoints.up('md')]: {
                padding: 0,
                minWidth: 0,
              },
            },
          },
        },
        MuiIconButton: {
          styleOverrides: {
            root: {
              padding: theme.spacing(1),
            },
          },
        },
        MuiTooltip: {
          styleOverrides: {
            tooltip: {
              borderRadius: 4,
            },
          },
        },
        MuiDivider: {
          styleOverrides: {
            root: {
              backgroundColor: 'rgb(255,255,255,0.15)',
            },
          },
        },
        MuiListItemButton: {
          styleOverrides: {
            root: {
              '&.Mui-selected': {
                color: '#4fc3f7',
              },
            },
          },
        },
        MuiListItemText: {
          styleOverrides: {
            primary: {
              fontSize: 14,
              fontWeight: theme.typography.fontWeightMedium,
            },
          },
        },
        MuiListItemIcon: {
          styleOverrides: {
            root: {
              color: 'inherit',
              minWidth: 'auto',
              marginRight: theme.spacing(2),
              '& svg': {
                fontSize: 20,
              },
            },
          },
        },
        MuiAvatar: {
          styleOverrides: {
                root: {
                    width: 32,
                    height: 32,
                },
            },
        }
    }
}

// Theme to use
export default defaultTheme;